import * as React from 'react';
import { Box, Card, CardContent, Container, Grid, Typography, useMediaQuery } from '@mui/material';
import image from '../../assets/header_tech.jpg'
import aipart1 from '../../assets/aipart1.png'
import approach from '../../assets/approach.jpg'
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Background from '../../component/backgroundlayout';
import { height } from '@fortawesome/free-brands-svg-icons/fa42Group';
import TechSlider from '../technology/slider';
import SliderBenifit from './cardslider';
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    };
}
const Technology = () => {
    const isLargeScreen = useMediaQuery('(min-width:2560px)');
    const isSmallScreen = useMediaQuery('(max-width:425px)');
    const isTabScreen = useMediaQuery('(max-width:768px)');
    const isMidScreen = useMediaQuery('(max-width:1024px)');
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (
        <>
            <Container
                disableGutters
                maxWidth={false}
                style={{ padding: '0', margin: '0', textAlign: 'center' }} // Remove any padding or margin
            >
               <TechSlider/>
            </Container>
            <Container style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', marginTop: '50px', marginBottom: "50px", justifyContent: 'space-between' }}>
                <Grid container spacing={5}>
                    <Grid item xs={12} md={6} lg={6} >
                        <Typography
                            variant='h4'
                            style={{
                                color: "#0B77A8",
                                fontFamily: "Poppins, sans-serif",
                                fontWeight: "600",
                                marginRight: '40px', // Space between the title and the paragraph
                                marginLeft: '0', // Remove left margin or adjust as needed
                                textAlign: 'left', // Align text to the left
                                whiteSpace: 'nowrap', // Prevent the text from wrapping to a new line
                                overflow: 'hidden', // Hide overflow text
                                textOverflow: 'ellipsis' // Add ellipsis for overflow text if needed
                            }}
                        >
                            Our Technology
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <p
                            style={{
                                fontSize: isLargeScreen
                                    ? "1.5rem"
                                    : isSmallScreen
                                        ? "0.7rem"
                                        : isTabScreen
                                            ? "1.2rem"
                                            : isMidScreen
                                                ? "1.2rem"
                                                : "1.2rem",
                                color: "#5A5959",
                                fontFamily: "Poppins, sans-serif",
                                fontWeight: "400",
                                lineHeight: "1.5",
                                flex: 1, // Allow the paragraph to take up remaining space
                                textAlign: 'left', // Align text to the left for the paragraph
                                margin: '0', // Remove default margins to better align with the heading
                                // minHeight: '5em',
                                marginLeft: "30px"
                            }}
                        >
                            Edgology is a dynamic and innovative company that is revolutionizing the education industry.
                            Our mission is to empower learners of all ages with the knowledge and skills they need to succeed in the 21st century.
                            We believe in creating a stimulating and collaborative environment where our team members can thrive and make a meaningful impact.
                        </p>
                    </Grid>

                </Grid>
            </Container>

            <Container maxWidth={false}
                sx={{ flexGrow: 1, bgcolor: '#FBFDFC', display: 'flex' }}
            >
                <Tabs
                    orientation="vertical"
                    variant="scrollable"
                    value={value}
                    onChange={handleChange}
                    // aria-label="Vertical tabs example"
                    sx={{
                        borderRight: 1,
                        borderColor: 'divider',
                        backgroundColor: "#1166A6",
                        borderRadius: "10px",
                        margin: "15px",
                        color: "white",
                        width: {
                            xs: "100px",
                            sm: "400px", // For small devices (tablets)
                            md: "400px", // For medium devices (laptops)
                            lg: "400px", // For large devices (desktops)
                            xl: "400px"
                        },
                        //  height:'max-content'
                    }}
                >
                    <Tab label="Automotive" sx={{
                        color: '#dfdfdf', fontSize: {
                            xs: "1.3rem", // For extra-small devices (phones)
                            sm: "1.3rem", // For small devices (tablets)
                            md: "1.3rem", // For medium devices (laptops)
                            lg: "1.5rem", // For large devices (desktops)
                            xl: "2.5rem"  // For extra-large devices (large desktops)
                        },
                    }}  {...a11yProps(0)} />
                    <Tab label="Education" sx={{
                        color: '#dfdfdf', fontSize: {
                            xs: "1.3rem", // For extra-small devices (phones)
                            sm: "1.3rem", // For small devices (tablets)
                            md: "1.3rem", // For medium devices (laptops)
                            lg: "1.5rem", // For large devices (desktops)
                            xl: "2.5rem"  // For extra-large devices (large desktops)
                        },
                    }}  {...a11yProps(1)} />
                    <Tab label="Health Care" sx={{
                        color: '#dfdfdf', fontSize: {
                            xs: "1.3rem", // For extra-small devices (phones)
                            sm: "1.3rem", // For small devices (tablets)
                            md: "1.3rem", // For medium devices (laptops)
                            lg: "1.5rem", // For large devices (desktops)
                            xl: "2.5rem"  // For extra-large devices (large desktops)
                        },
                    }}  {...a11yProps(2)} />
                    <Tab label="Hospitality" sx={{
                        color: '#dfdfdf', fontSize: {
                            xs: "1.3rem", // For extra-small devices (phones)
                            sm: "1.3rem", // For small devices (tablets)
                            md: "1.3rem", // For medium devices (laptops)
                            lg: "1.5rem", // For large devices (desktops)
                            xl: "2.5rem"  // For extra-large devices (large desktops)
                        },
                    }}  {...a11yProps(3)} />
                    <Tab label="Manufacturing" sx={{
                        color: '#dfdfdf', fontSize: {
                            xs: "1.3rem", // For extra-small devices (phones)
                            sm: "1.3rem", // For small devices (tablets)
                            md: "1.3rem", // For medium devices (laptops)
                            lg: "1.5rem", // For large devices (desktops)
                            xl: "2.5rem"  // For extra-large devices (large desktops)
                        },
                    }}  {...a11yProps(4)} />
                    <Tab label="Recruitment" sx={{
                        color: '#dfdfdf', fontSize: {
                            xs: "1.3rem", // For extra-small devices (phones)
                            sm: "1.3rem", // For small devices (tablets)
                            md: "1.3rem", // For medium devices (laptops)
                            lg: "1.5rem", // For large devices (desktops)
                            xl: "2.5rem"  // For extra-large devices (large desktops)
                        },
                    }} {...a11yProps(5)} />
                    <Tab label="Travel" sx={{
                        color: '#dfdfdf', fontSize: {
                            xs: "1.3rem", // For extra-small devices (phones)
                            sm: "1.3rem", // For small devices (tablets)
                            md: "1.3rem", // For medium devices (laptops)
                            lg: "1.5rem", // For large devices (desktops)
                            xl: "2.5rem"  // For extra-large devices (large desktops)
                        },
                    }} {...a11yProps(6)} />
                </Tabs>
                <TabPanel value={value} index={0} style={{ paddingBottom: "20px", width: "100%", height: "auto" }}>
                    <Card style={{
                        border: "2px solid",
                        borderColor: "#1166A6",
                        height: "auto",
                        marginBottom: "20px",
                        borderRadius: "15px",
                        width: "100%"
                    }}>
                        <CardContent>
                            <Typography variant='h4' style={{ fontWeight: 600, color: "#1166A6", fontSize: "26px" }}>
                                Tech-Driven Automotive Solutions
                            </Typography>
                            <Grid container style={{ display: "flex" }} spacing={4}>
                                <Grid item xs={12} sm={6}>
                                    <Box
                                        component='img'
                                        src={aipart1}
                                        style={{
                                            width: "100%", // Ensures it takes up the full width of the Grid item
                                            height: "auto", // Keeps the aspect ratio intact
                                            objectFit: "contain",
                                            borderRadius: "10px "// Ensures the image fits within its container
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant='h4'>
                                        Digital Innovation
                                    </Typography>
                                    <p>Revolutionizes business through transformation.</p>
                                    <p>Revolutionizes business through transformation.</p>
                                    <p>Revolutionizes business through transformation.</p>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </TabPanel>


                <TabPanel value={value} index={1}>
                    <SliderBenifit/>
                </TabPanel>
                <TabPanel value={value} index={2}>
                    Item Three
                </TabPanel>
                <TabPanel value={value} index={3}>
                    Item Four
                </TabPanel>
                <TabPanel value={value} index={4}>
                    Item Five
                </TabPanel>
                <TabPanel value={value} index={5}>
                    Item Six
                </TabPanel>
                <TabPanel value={value} index={6}>
                    Item Seven
                </TabPanel>
            </Container>
            <Container maxWidth={false} style={{ display: "flex", alignContent: "center", padding: "50px", paddingRight: "0px" }}>

                <Grid container spacing={5}>
                    <Grid item xs={6} >
                        <Typography variant='h3' sx={{
                            marginBottom: {
                                xl: "30px",
                                xs: "1.3rem", // For extra-small devices (phones)
                                sm: "1.3rem", // For small devices (tablets)
                                md: "20px", // For medium devices (laptops)
                                lg: "30px"
                            },
                            color:"#0B77A8"
                        }}>Approach</Typography>
                        <Typography
                            component="p"
                            sx={{
                                fontSize: {
                                    xs: "0.5rem", // For extra-small devices (phones)
                                    sm: "0.7rem", // For small devices (tablets)
                                    md: "0.9rem", // For medium devices (laptops)
                                    lg: "1.3rem", // For large devices (desktops)
                                    xl: "2.0rem",  // For extra-large devices (large desktops)
                                    xxl: "2.5rem"
                                },
                            }}
                        >

                            At Edgology, we believe that technology is the driving force behind every successful modern business.
                            Our approach centers on delivering tailored, innovative IT solutions that not only meet current business needs but also prepare our clients for future challenges.
                            We specialize in leveraging cutting-edge technologies to streamline operations, optimize performance, and enable growth across industries.
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Box component='img' src={approach} style={{ objectFit: "contain" }} sx={{
                            width: {
                                xl: "80%",
                                lg: "70%",
                                md: "70%",
                                sm: "100%",
                                xs: "90%",
                            },
                        }} />
                    </Grid>
                </Grid>

            </Container >
            <Card style={{margin:"30px",borderRadius:"15px",border:"2px solid #0B77A8"}}>
                <CardContent>
                    <Typography variant='h3' color='#0B77A8'>
                    Let's Build Something Great Together
                    </Typography>
                    <Typography component='p' color="#585858">
                    Ready to take your business to the next level with the power of technology? Contact us today to discuss your project and how we can help turn your vision into reality.
                    </Typography>
                </CardContent>
            </Card>
        </>
    )
};
export default Technology;